export default __webpack_public_path__ + "static/media/on-prem-logo.43fb8beb.svg";